import type { Triptype } from "@/features/trips/types/trip.types";
import type { UserReference } from "@/types/user.types";

export interface Invoice {
	id?: string;
	user?: UserReference;
	invoiceNumber?: string;
	issuedDate?: string;
	dueDate?: string;
	totalAmount?: number;
	tripType?: Triptype;
	status?: InvoiceStatus;
}

export type InvoiceStatus = (typeof invoiceStatus)[keyof typeof invoiceStatus];

export const invoiceStatus = {
	PENDING: "PENDING",
	PAID: "PAID",
	OVERDUE: "OVERDUE",
} as const;
